import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'
import CodeEditor from './code_editor.js'

function cloneTemplate(template) {
  return {
    name: '',
    human_type: '',
    raw_body: '',
    scss: '',
    javascript: '',
    ...(template || {})
  }
}

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'code-editor': CodeEditor
  },

  props: {
    formData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      template: cloneTemplate(this.formData.template),
      saving: false
    }
  },

  computed: {
    paths() {
      return this.formData.paths || {}
    },

    title() {
      return `修改${this.template.name}`
    }
  },

  methods: {
    saveTemplate(event) {
      event.preventDefault()
      this.saving = true
      $.ajax({
        url: this.paths.update,
        type: 'patch',
        dataType: 'json',
        data: {
          template: this.template
        },
        success: (payload) => {
          if (payload.template) this.template = cloneTemplate(payload.template)
          Skylark.Bridge.newAlertify(payload.message || '模板更新成功', { type: 'success' })
        },
        error: (xhr) => {
          let msg = '模板更新失败'
          try {
            msg = JSON.parse(xhr.responseText).message || msg
          } catch (e) {
            // ignore
          }
          Skylark.Bridge.newAlertify(msg, { type: 'danger' })
        },
        complete: () => {
          this.saving = false
        }
      })
    }
  },

  template: `
    <settings-container active-tab="message_exception_templates">
      <template slot="content">
        <div class="templates-settings template-form-page message-exception-template-form-page">
          <div class="template-form-header">
            <div>
              <div class="templates-kicker">消息异常模板设置</div>
              <h1>{{ title }}</h1>
              <p>都留空表示使用默认的消息异常页面。</p>
            </div>
            <a :href="paths.index" class="btn btn-default btn-small outlined">返回模板列表</a>
          </div>

          <div class="template-form-card">
            <form class="template-form" @submit="saveTemplate">
              <div class="message-exception-template-note">
                都留空表示使用默认的
              </div>
              <div class="template-editor-grid">
                <code-editor label="HTML"
                             name="template[raw_body]"
                             mode="text/html"
                             v-model="template.raw_body" />
                <code-editor label="SCSS"
                             name="template[scss]"
                             mode="text/css"
                             v-model="template.scss" />
                <code-editor label="JavaScript"
                             name="template[javascript]"
                             mode="text/javascript"
                             v-model="template.javascript" />
              </div>

              <div class="template-form-actions">
                <a :href="paths.index" class="btn btn-default outlined">取消</a>
                <button type="submit" class="btn btn-success" :disabled="saving">
                  {{ saving ? '保存中...' : '更新' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </template>
    </settings-container>
  `
})
